"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _forEach = _interopRequireDefault(require("lodash/forEach"));
var _react = _interopRequireWildcard(require("react"));
var _Select = _interopRequireDefault(require("../../../Select/Select"));
var _TableSortType = _interopRequireDefault(require("./TableSortType"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  ASC,
  DESC
} = _TableSortType.default;
class TableSortSelector extends _react.Component {
  constructor(props) {
    super(props);
    this._HEADERS = props.headers;
    this._sortItems = [];
    (0, _forEach.default)(this._HEADERS, ({
      isSortable,
      label,
      dataKey
    }) => {
      if (isSortable) {
        this._sortItems.push({
          label: `${label} - ${ASC}`,
          value: `${dataKey}-${ASC}`
        });
        this._sortItems.push({
          label: `${label} - ${DESC}`,
          value: `${dataKey}-${DESC}`
        });
      }
    });
  }
  _onSortChange = ({
    value
  }) => {
    const [dataKey, sortOrder] = value.split('-');
    this.props.onSortChange({
      dataKey,
      sortOrder
    });
  };
  render() {
    const {
      sortOrder,
      sortDataKey
    } = this.props;
    const defaultSortValue = sortDataKey && sortOrder ? `${sortDataKey}-${sortOrder}` : null;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "TableSortSelector"
    }, /*#__PURE__*/_react.default.createElement(_Select.default, {
      key: defaultSortValue,
      className: "TableSortSelector-Select",
      defaultValue: defaultSortValue,
      items: this._sortItems,
      onChange: this._onSortChange
    }));
  }
}
exports.default = TableSortSelector;